import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import * as CartUtils from "@omni/utils/cart.utils";

export const getCartSkuList = (cart?: Cart | null) => {
    const isRecommendationsAllowed = ({
        id,
        articleConfiguration,
        product
    }: CartItem) =>
        !articleConfiguration &&
        !CartUtils.productIsAdditionalService(cart?.items || [], id) &&
        !product?.giftCardArticle;

    return (
        cart?.items.filter(isRecommendationsAllowed).map((item) => item.sku) ??
        []
    );
};
